import { DashOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema.ts';
import { type IPageBreakWidget } from './IPageBreakWidget.ts';
import { PageBreakConfigComponent } from './PageBreakConfigComponent.tsx';
import { PageBreakPreviewComponent } from './PageBreakPreviewComponent.tsx';
import { PageBreakWidgeComponent } from './PageBreakWidgeComponent.tsx';
import { renderPageBreakHtml } from './renderPageBreakHtml.ts';

export const PageDividerWidgetConfigSchema: yup.ObjectSchema<IPageBreakWidget> =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.PageBreak).required(),
  })
    .required()
    .noUnknown();

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const PageBreakWidgetType: IWidgetType<IPageBreakWidget> = {
  type: WidgetType.PageBreak,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Interruzione di Pagina',
  icon: <DashOutlined />,
  hasValue: false,
  formComponent: PageBreakWidgeComponent,
  configComponent: PageBreakConfigComponent,
  configValidator: PageDividerWidgetConfigSchema,
  previewComponent: PageBreakPreviewComponent,
  translationSchema: tran.widget({}),
  rules: [],
  renderHtml: renderPageBreakHtml,
};
